import { combineReducers } from "redux";
import tenantDetailsReducer from '../Redux/Reducer/tenantDetailsReducer';


const rootReducer = combineReducers({
  tenantDetails: tenantDetailsReducer,
  // other reducers
});

export default rootReducer;